import { Button, Stack, Typography } from '@mui/material';
import ExamDatePicker, { INVALID_EXAM_DATE } from './ExamDatePicker';
import { EXAM_DATE_ERROR_MESSAGE, EXAM_DATE_INCOMPLETE_MESSAGE, isValidExamDate } from '../utils/examDate';

export default function ExamSettingsFields({
  targetExamLevel,
  onTargetExamLevelChange,
  examDate,
  onExamDateChange,
  disabled = false,
}) {
  const examDateInvalid = !isValidExamDate(examDate);

  return (
    <Stack spacing={2} sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        Target level (optional)
      </Typography>
      <Stack direction="row" spacing={1} role="group" aria-label="Target level (optional)">
        {['A1', 'A2', 'B1'].map((level) => (
          <Button
            key={level}
            type="button"
            translate="no"
            className="notranslate"
            variant={targetExamLevel === level ? 'contained' : 'outlined'}
            aria-pressed={targetExamLevel === level}
            onClick={() => onTargetExamLevelChange(targetExamLevel === level ? '' : level)}
            disabled={disabled}
            sx={{ flex: 1 }}
          >
            {level}
          </Button>
        ))}
      </Stack>
      <ExamDatePicker
        label="Exam date (optional)"
        value={examDate}
        onChange={onExamDateChange}
        error={examDateInvalid}
        helperText={
          examDate === INVALID_EXAM_DATE
            ? EXAM_DATE_INCOMPLETE_MESSAGE
            : examDateInvalid
              ? EXAM_DATE_ERROR_MESSAGE
              : undefined
        }
        disabled={disabled}
      />
    </Stack>
  );
}
